<template>
  <span :style="`color: ${color}`">{{ answerText }}</span>
</template>

<script>
import authorAnswerColors from './mixins/authorAnswerColors';
export default {
  props: ['questionAnswer', 'show', 'questionId'],
  mixins: [authorAnswerColors],
  computed: {
    answerData() {
      return this.answers.find(a => a.value == this.questionAnswer.answer);
    },
    answerText() {
      if (this.answerData) {
        const confidence =
          this.questionAnswer.confidence == 2 ? "and Pretty Sure" : 'but not sure yet';
        return this.answerData.text[0] + ' ' + this.answerData.text[1] + ' ' + confidence;
      } else {
        return 'NO ANSWER YET'
      }
      
    },
    color() {
      return this.questionAnswer.answer ? this.colors[this.questionAnswer.answer] : this.colors[0];
    }
  }
};
</script>
